import * as React from 'react';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import Iconify from '@simplytech/simply.general.iconify';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#222',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#222',
    fontSize: 10,
  },
}));

export default function Verified() {
  return (
    <StyledTooltip
      title={
        <Stack direction="row" alignItems="center">
          <Box sx={{ position: 'relative' }}>
            <Iconify
              icon={'ic:round-verified'}
              width={18}
              height={18}
              style={{
                marginTop: 1,
                color: '#0DA800',
                position: 'relative',
                zIndex: 1,
              }}
              // backgroundColor: `${alpha(theme.palette.primary.main, 0.08)}`,
            />
            <Box
              sx={{
                width: 10,
                height: 10,
                backgroundColor: '#fff',
                position: 'absolute',
                top: 4,
                left: 4,
                borderRadius: '50%',
                zIndex: 0,
              }}
            />
          </Box>
          <Box sx={{ ml: 0.5 }} />
          <Typography sx={{ fontSize: 10 }}>Verified by Simply</Typography>
        </Stack>
      }
      placement="top"
    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }}>
          <Iconify
            icon={'ic:round-verified'}
            width={18}
            height={18}
            style={{
              marginTop: 1,
              color: '#0DA800',
              position: 'relative',
              zIndex: 1,
            }}
            // backgroundColor: `${alpha(theme.palette.primary.main, 0.08)}`,
          />
          <Box
            sx={{
              width: 10,
              height: 10,
              backgroundColor: '#fff',
              position: 'absolute',
              top: 4,
              left: 4,
              borderRadius: '50%',
              zIndex: 0,
            }}
          />
        </Box>
      </Stack>
    </StyledTooltip>
  );
}
